import { isPotentialOffering, LiveDataOffering, PotentialOffering } from 'types'
import { Statistic } from 'components/molecules/Statistic'
import { HelpInfo } from 'components/molecules/HelpInfo'
import { getOfferingApy } from 'domain/offering/getOfferingApy'
import { isAssetOffering } from 'types/Portfolio/StructuredOffering'
import { APYCalculationMethodModal } from 'components/Portfolios/APYCalculationMethodModal'
import { Row } from 'components/atoms/Row'
import { isFeatureEnabled } from 'utils'
import { AUTOMATIC_APY_CALCULATION } from 'constants/apyCalculation'
import styled from 'styled-components'
import { InfoWithLabel } from './InfoWithLabel'

interface Props {
  portfolio: LiveDataOffering | PotentialOffering
  label?: string
  isManager?: boolean
}

export const PortfolioApyStatistic = ({ portfolio, label, isManager }: Props) => {
  const isNotPotential = !isPotentialOffering(portfolio)
  const displayApyEditButton =
    isManager && isNotPotential && portfolio.status === 'Open' && isFeatureEnabled('apyOverride')

  const apyCalculationMethod = isNotPotential ? portfolio.apyCalculationMethod : undefined
  const manualAPYOverride = (isNotPotential && portfolio.manualAPYOverride) || undefined
  const currentApy = isAssetOffering(portfolio) ? portfolio.currentApyInBPS : undefined
  return (
    <Statistic
      view="column"
      label={
        <HelpInfo
          title={getTitle(portfolio, label)}
          info={
            <InfoWithLabel
              method={apyCalculationMethod}
              currentApyInBPS={currentApy}
              manualAPYOverride={manualAPYOverride}
            />
          }
        />
      }
      text={
        <StyledRow>
          {getOfferingApy(portfolio)}
          {displayApyEditButton && <APYCalculationMethodModal offering={portfolio} />}
        </StyledRow>
      }
      variant="title2"
      extraBold
    />
  )
}

function getTitle(portfolio: LiveDataOffering | PotentialOffering, label?: string) {
  if (label) {
    return label
  }

  if (!isPotentialOffering(portfolio) && portfolio.apyCalculationMethod === 'manual' && !!portfolio.manualAPYOverride) {
    return portfolio.manualAPYOverride.name
  }

  if (isAssetOffering(portfolio) && portfolio.currentApyInBPS) {
    return AUTOMATIC_APY_CALCULATION.name
  }

  return 'Target Return'
}

const StyledRow = styled(Row)`
  gap: 16px;
`
